module.exports = 'http://18.231.6.135:8080';

// module.exports = 'http://192.168.2.57:8003/'
